import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Slider, Typography } from '@mui/material';

import InfoIcon from '@mui/icons-material/Info';
import LocalizedTooltip from '/b2b/common/components/LocalizedTooltip';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import styles from './ValidationSlider.styles';
import { v4 as uuid } from 'uuid';

const useStyles = makeStyles()(styles);

const ValidationSlider = props => {
    const { value, onChange, error, label, tooltip, ...remain } = props;
    const { classes, cx } = useStyles();
    const uid = useRef(uuid());
    const [newValue, setNewValue] = useState(value);
    const handleChange = (event, value) => {
        const newValue = value;
        setNewValue(newValue);
    };

    const handleChangeCommitted = (event, value) => {
        const newValue = value;
        onChange && onChange(newValue);
    };

    useEffect(() => {
        setNewValue(value);
    }, [value]);

    const labelClass = cx(classes.label, error ? classes.error : '');

    return (
        <Fragment key={uid.current}>
            <Typography className={labelClass} gutterBottom>
                <span id={uid.current}>{label}</span>
                {tooltip ? (
                    <LocalizedTooltip title={tooltip}>
                        <span className={classes.infoIcon} role="img" tabIndex={0}>
                            <InfoIcon fontSize="inherit" />
                        </span>
                    </LocalizedTooltip>
                ) : null}
            </Typography>
            <div className={classes.sliderContainer}>
                <Slider
                    className={classes.slider}
                    aria-labelledby={uid.current}
                    valueLabelDisplay="auto"
                    color="primary"
                    defaultValue={value}
                    onChange={handleChange}
                    onChangeCommitted={handleChangeCommitted}
                    value={newValue}
                    {...remain}
                />
            </div>
        </Fragment>
    );
};

ValidationSlider.propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.number,
    min: PropTypes.number,
    marks: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.any.isRequired,
                label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
        PropTypes.arrayOf(PropTypes.string),
    ]),
    step: PropTypes.number,
};

export default ValidationSlider;
